import { put, call, select, fork, take } from "redux-saga/effects";
import {
  VALIDATE_FORM_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_REQUEST,
  END_ACTION,
} from "./actionTypes";

const ERROR_MESSAGE_KEYS = [
  "currentPassword",
  "newPassword",
  "confirmNewPassword",
  "passwordMismatch",
];

interface ChangePasswordFormData {
  current_username?: string;
  current_user_password?: string;
  new_user_password?: string;
  new_user_password_confirm?: string;
}

export function validateChangePasswordForm(formValues: ChangePasswordFormData) {
  // Test validate return ok always
  const error = [];
  let ok = true;

  if (!formValues.current_user_password) {
    error.push(ERROR_MESSAGE_KEYS[0]);
  }

  if (!formValues.new_user_password) {
    error.push(ERROR_MESSAGE_KEYS[1]);
  }

  if (!formValues.new_user_password_confirm) {
    error.push(ERROR_MESSAGE_KEYS[2]);
  }

  if (formValues.new_user_password !== formValues.new_user_password_confirm) {
    error.push(ERROR_MESSAGE_KEYS[3]);
  }

  if (error.length > 0) {
    ok = false;
  }

  return {
    ok,
    error,
  };
}

// SELECTORS
const getAuthToken = (state: Insite.AppState) => state.auth.user.token;
const getChangePasswordFormValues = (state: Insite.AppState) =>
  state.profile.profile_form_data;
const getCurrentUsername = (state: Insite.AppState) => state.auth.user.username;

function* changePassword(row: ChangePasswordFormData, token: string) {
  // TODO: Saga doesn't expect our weird middleware, so `any` is required
  const action: any = {
    types: [CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAIL],
    // TODO: ApiClient needs typing... or maybe just delete the middleware/apiclient and use axios
    promise: (client: any) =>
      client.post(`/user/${row.current_username}/update-password`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          current_password: row.current_user_password,
          new_password: row.new_user_password,
        },
      }),
  };
  yield put(action);
}

/**
 * @param response I have no idea what this is
 * @param func This is always the changePassword function, why is this necessary?
 * @param user TODO: Requires types
 * @param auth TODO: Requires types
 */
export function* executeUserAction(
  response: any,
  func: typeof changePassword,
  user: any,
  auth: any
) {
  if (response.ok) {
    // call add user asynchronously
    yield fork(func, user, auth);
  } else {
    // Return errors in form - Better to use redux form
    yield put({ type: VALIDATE_FORM_ERROR, error: response.error });
  }
}

export function* changePasswordFlow(): Generator<any, any, any> {
  while (true) {
    // Wait for start of cycle action
    yield take(CHANGE_PASSWORD_REQUEST);

    // Get values from form - Better to use redux form
    const passwordFormValues = yield select(getChangePasswordFormValues);
    const token = yield select(getAuthToken);
    const currentUsername = yield select(getCurrentUsername);

    // add current_username to values sent to changePassword
    passwordFormValues.current_username = currentUsername;

    // Validate - Better to do this with redux form
    const response = yield call(validateChangePasswordForm, passwordFormValues);

    // Change Password task
    yield fork(
      executeUserAction,
      response,
      changePassword,
      passwordFormValues,
      token
    );

    // Wait for end of cycle action
    yield take([
      CHANGE_PASSWORD_SUCCESS,
      CHANGE_PASSWORD_FAIL,
      END_ACTION,
      VALIDATE_FORM_ERROR,
    ]);
  }
}
